import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@heroui/button';
import { FaCirclePlus, FaDeleteLeft, FaArrowRightArrowLeft } from 'react-icons/fa6';

import ChordPicker from '@/components/ChordPicker/ChordPicker.tsx';
import useProgression from '@/hooks/useProgression.ts';

function ProgressionOptions() {
  const { t } = useTranslation();

  const {
    progressionOptionBars,
    selectedChord,
    selectedProgression,
    progression,
    undoProgression,
    addChord,
  } = useProgression();

  const isReplace = useMemo(
    () => selectedProgression < progression.length,
    [selectedProgression, progression.length],
  );

  return (
    <div className="py-4 sm:py-8">
      <div className="gap-4 flex flex-col">
        {progressionOptionBars.map((picker, index) => (
          <ChordPicker key={picker.name} picker={picker} pickerIndex={index} />
        ))}
      </div>
      <div className="mt-4 sm:mt-8 gap-1 sm:gap-2 flex">
        <Button
          isDisabled={progression.length === 0}
          size="lg"
          startContent={<FaDeleteLeft />}
          variant="bordered"
          onPress={undoProgression}
        >
          {t('progression.undo')}
        </Button>
        <Button
          isDisabled={!selectedChord}
          size="lg"
          startContent={isReplace ? <FaArrowRightArrowLeft /> : <FaCirclePlus />}
          onPress={addChord}
        >
          {isReplace ? t('progression.replace') : t('progression.add')}
        </Button>
      </div>
    </div>
  );
}

export default ProgressionOptions;
